import PayRollDeviation from '../model/payRollDeviation'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchPayRollDeviations(payRollID: string): Promise<RequestResponse<PayRollDeviation[]>> {
  return secureRequest('GET', url('/v2/payRollDeviations', { payRollID }))
}
